import React from 'react';
import { Skeleton } from 'antd';

import { blokTestConst } from 'modules/blok-test';

interface IProps {
  isCoursesLoading?: boolean;
  testType?: string;
}

export const ResultSkeleton: React.FC<IProps> = ({ isCoursesLoading, testType }) => (
  <>
    {testType === blokTestConst.testTypes.TOPIC_TEST ? (
      <div className="mt-4 grid grid-cols-1 gap-3 lg:grid-cols-2">
        <div className="rounded-xl bg-white p-4">
          <div className="flex justify-center ">
            <Skeleton.Avatar size={100} active />
          </div>
          <div className="mt-4 flex justify-center">
            <Skeleton.Input active className="!h-5" />
          </div>
          <div className="flex items-center gap-2">
            <Skeleton.Input active className="!h-15 mt-3 !w-full !rounded-xl" />
            <Skeleton.Input active className="!h-15 mt-3 !w-full !rounded-xl" />
          </div>
          <Skeleton.Input active className="mt-3 !h-10 !w-full !rounded-xl" />
          <div className="mt-5 grid grid-cols-4 gap-2 md:grid-cols-10">
            {Array.from({ length: 20 }).map((_, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Skeleton.Avatar size={32} key={index} active />
            ))}
          </div>
          <div className="mt-5 flex items-center justify-center gap-3">
            <Skeleton.Button active className="!h-16 !rounded-xl" />
            <Skeleton.Button active className="!h-16 !rounded-xl" />
            <Skeleton.Button active className="!h-16 !rounded-xl" />
          </div>

          <Skeleton.Button active className="!my-4 !h-10 !w-full !rounded-xl" />
        </div>
        {isCoursesLoading && (
          <div className="rounded-xl bg-white p-4">
            <div className="flex items-center justify-between">
              <Skeleton.Input active className="!h-5" />
              <Skeleton.Input active className="!h-5" />
            </div>
            <div className="my-2">
              {Array.from({ length: 6 }).map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Skeleton.Input key={index} active className="mt-3 !h-20 !w-full !rounded-xl" />
              ))}
            </div>
          </div>
        )}
      </div>
    ) : (
      <div className="mx-auto mt-10 max-w-[40rem]">
        <div className="rounded-xl bg-white p-4">
          <div className="flex justify-center ">
            <Skeleton.Avatar size={100} active />
          </div>
          <div className="mt-4 flex justify-center">
            <Skeleton.Input active className="!h-5" />
          </div>
          <div className="flex items-center gap-2">
            <Skeleton.Input active className="!h-15 mt-3 !w-full !rounded-xl" />
            <Skeleton.Input active className="!h-15 mt-3 !w-full !rounded-xl" />
          </div>
          <Skeleton.Input active className="mt-3 !h-10 !w-full !rounded-xl" />
          <div className="mt-5 grid grid-cols-4 gap-2 md:grid-cols-10">
            {Array.from({ length: 20 }).map((_, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Skeleton.Avatar size={32} key={index} active />
            ))}
          </div>
          <div className="mt-5 flex items-center justify-center gap-3">
            <Skeleton.Button active className="!h-16 !rounded-xl" />
            <Skeleton.Button active className="!h-16 !rounded-xl" />
            <Skeleton.Button active className="!h-16 !rounded-xl" />
          </div>

          <Skeleton.Button active className="!my-4 !h-10 !w-full !rounded-xl" />
        </div>
      </div>
    )}
  </>
);